import { CoreTwilioServiceClient } from "mongodb-stitch-core-services-twilio";
import TwilioServiceClientImpl from "./internal/TwilioServiceClientImpl";
export var TwilioServiceClient;
(function (TwilioServiceClient) {
    TwilioServiceClient.factory = new (function () {
        function class_1() {
        }
        class_1.prototype.getNamedClient = function (service, client) {
            return new TwilioServiceClientImpl(new CoreTwilioServiceClient(service));
        };
        return class_1;
    }())();
})(TwilioServiceClient || (TwilioServiceClient = {}));
//# sourceMappingURL=TwilioServiceClient.js.map